import { api } from '../lib/axios';

import type { VectorEmbeddingModel } from '../types/vector';

interface CreateVectorMetadatasBody {
  filesIds: Array<string>;
  metadatas: Array<{
    name: string;
    value: string;
  }>;
  embeddingModelName: VectorEmbeddingModel;
}

async function createVectorMetadatas(body: CreateVectorMetadatasBody) {
  const response = await api.post('/vector/metadata/add', body);

  return response.data;
}

export { createVectorMetadatas, type CreateVectorMetadatasBody };
